import { PayloadAction } from "@reduxjs/toolkit";
import { createApi, createSlice } from "utils/@reduxjs/toolkit";
import { useInjectReducer, useInjectSaga } from "utils/redux-injectors";
import { DigitalSecurityPlansState } from "./types";
import { baseQuery, endpoints, formatErrors } from "utils/api/endpoints";

export const initialState: DigitalSecurityPlansState = {
  digitalSecurityPlan: null,
  activeTab: null,
};

const slice = createSlice({
  name: "digitalSecurityPlans",
  initialState,
  reducers: {
    setPlan: (state, action: PayloadAction<{plan: any, activeTab: string}>) => {
      state.digitalSecurityPlan = action.payload.plan;
      state.activeTab = action.payload.activeTab;
    },
  },
});

export const api = createApi({
  reducerPath: "digitalSecurityPlansApi",
  baseQuery,
  endpoints: (builder) => ({
    getDigitalSecurityPlans: builder.query({
      query: (params) => {
        return {
          ...endpoints.digitalSecurityPlans,
          params,
        };
      },
      transformErrorResponse(baseQueryReturnValue, meta, arg) {
        return formatErrors(baseQueryReturnValue.data);
      },
    }),
  }),
});

export const { actions: Actions } = slice;

export const useDigitalSecurityPlansSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  return { actions: slice.actions, ...api };
};

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
